export default {
	SET_LOGIN_TOKEN (state, val) {
		state.loginToken = val
	},
	SET_PASSWORD_TOKEN (state, val) {
		state.passwordToken = val
	},
	SET_ACCESS_TOKEN (state, val) {
		state.accessToken = val
	},
	SET_TOKEN_TYPE (state, val) {
		state.tokenType = val
	},
	SET_SIGNUP_TOKEN (state, val) {
		state.signupToken = val
	},
	SET_SIGNUP_CONFIRM_CODE (state, val) {
		state.confirmCode = typeof val === 'string' && val ? val : ''
	},
	SET_SIGNUP_CONFIRM_CODE_LENGTH (state, val) {
		state.confirmCodeLength = isNaN(val) ? 6 : parseInt(val)
	},
	SET_SIGNUP_EMAIL (state, val) {
		state.signupEmail = typeof val === 'string' && val ? val : ''
	},
	SET_COMPANY_CODE (state, val) {
		state.companyCode = val
	},
	SET_LOADING (state, val) {
		state.loading = val
	}
}
